import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EntityState } from '../../interfaces/entity-state';

@Injectable({
  providedIn: 'root'
})
export class GenericStateService<T extends { _id: string }> {

  private stateSubject = new BehaviorSubject<EntityState<T>>({
    list: [],
    map: {}
  });

  readonly state$: Observable<EntityState<T>> = this.stateSubject.asObservable();

  constructor() { }


  setEntities(entities: T[]) {
    const map = entities.reduce((acc, entity) => {
      acc[entity._id] = entity;
      return acc;
    }, {} as { [id: string]: T });

    this.stateSubject.next({
      list: entities,
      map
    });
  }


  setEntitiesNew(entities: any) {
    this.stateSubject.next({
      list: entities.value,
      map:entities
    });
  }

  get currentState(): EntityState<T> {
    return this.stateSubject.getValue();
  }

  getById(id: string): T | undefined {
    return this.currentState.map[id];
  }

  addEntity(entity: T) {
    const newList = [...this.currentState.list, entity];
    const newMap = { ...this.currentState.map, [entity._id]: entity };
    this.stateSubject.next({ list: newList, map: newMap });
  }

  removeEntity(id: string) {
    const newList = this.currentState.list.filter(e => e._id !== id);
    const { [id]: _, ...newMap } = this.currentState.map;
    this.stateSubject.next({ list: newList, map: newMap });
  }
}
